<script setup lang="ts">
import { type FrontContent } from "@gasparigit/omnia-sdk";
import { getContentType, link } from "~/lib/utils/contents";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: FrontContent;
  compact?: boolean;
  showAreas?: boolean;
  infoLabel?: string;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentItemsBaseItem
    v-bind="$props"
    :class="$attrs?.class"
    :title="content.title"
    :abstract="content.abstract"
    :info-label="infoLabel || getContentType(content)"
    :areas="content.areas"
    :date="content.published_at || content.created_at"
    :link="linkConfig ? link({ ...linkConfig, content }) : undefined"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData"></slot>
    </template>
  </FrontContentItemsBaseItem>
</template>
